var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NuxtLink',{class:_vm.button ? 'button' : 'link',attrs:{"to":_vm.path,"prefetch":_vm.prefetch},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }